import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { useRef, useState } from 'react';
import { useSite } from '../../context/site';
import DateRangeReport from './date-range-select';

function StateReport14() {
    const { GetStateReport14 } = useSite();

    const dt = useRef(null);

    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [dateBegin, setDateBegin] = useState(new Date());
    const [dateEnd, setDateEnd] = useState(new Date());
    const [run, setRun] = useState(true);

    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({ selectionOnly });
    };

    // On rows change
    // useEffect(() => {
    //     console.log(rows);
    // }, [rows]);

    if (run) {
        return (
            <>
                <DateRangeReport
                    onRunReport={({ start, end }) => {
                        setLoading(true);
                        setDateBegin(new Date(start));
                        setDateEnd(new Date(end));
                        GetStateReport14({ start, end }, (res) => {
                            setRows(res.data.rows);
                            setLoading(false);
                            setRun(false);
                        });
                    }}
                />
            </>
        );
    }

    return (
        <>
            <div className="mt-2">
                <Button label="Change Date" icon="pi pi-check" onClick={() => setRun(true)} />
            </div>

            <div className="mt-2">
                <span>Start Date: {dateBegin.toLocaleDateString()}</span>
            </div>

            <div className="mt-2">
                <span>End Date: {dateEnd.toLocaleDateString()}</span>
            </div>

            <div className="mt-2">
                <DataTable
                    ref={dt}
                    header={
                        <Button
                            type="button"
                            icon="pi pi-file"
                            rounded
                            onClick={() => exportCSV(false)}
                            data-pr-tooltip="CSV"
                        />
                    }
                    value={rows}
                    emptyMessage="No programs found"
                    showGridlines
                    removableSort
                    paginator
                    rows={5}
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    loading={loading}
                >
                    <Column field="programName" header="Program Name"></Column>
                    <Column field="programType" header="Program Type"></Column>
                    <Column field="totalDurationHours" header="Total Duration Hours"></Column>
                    <Column field="totalDurationMinutes" header="Total Duration Minutes"></Column>
                    <Column field="totalDuration" header="Total Duration"></Column>
                </DataTable>
            </div>
        </>
    );
}

export default StateReport14;
